/* eslint-disable @typescript-eslint/no-explicit-any */
import { FirebaseOptions } from 'firebase/app';
import {
    FirebaseChannelConnection,
    FirebaseChannelsClientTransport,
} from './firebase-channel.model';

export const toFirebaseOptions = (record: any): FirebaseOptions => ({
    apiKey: record.firebaseApiKey,
    authDomain: record.firebaseAuthDomain,
    databaseURL: record.firebaseDatabaseURL,
    messagingSenderId: record.firebaseMessagingSenderId,
    projectId: record.firebaseProjectId,
});

export const toFirebaseChannelConnection = (
    response: any,
    clientTransport: FirebaseChannelsClientTransport,
): FirebaseChannelConnection => ({
    channelId: response.channelConnection.channelId,
    clientTransport,
    firebaseChannelPath:
        response.channelConnection.connectionParams.firebaseChannelPath,
});
